module.exports = __webpack_public_path__ + "img/wein-nachhaltigkeit.d6a0a7a9.jpg";